<template>
  <div class="wrap">
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>

    <!--   列表     -->
    <el-table
      ref="table"
      class="listTable"
      :data="treeList"
      :cell-style="cellStyle"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      border
      row-key="id"
      default-expand-all
      :max-height="750"
    >
      <el-table-column label="部门名称" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.deptName ? scope.row.deptName : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        min-width="160"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发起人" min-width="160" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.createBy ? scope.row.createBy: '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <div class="operation">
            <el-button type="text" @click="handleAdd( scope.row, '新增')">新增</el-button>
            <el-button type="text" @click="handleEdit(scope.row, '编辑')">编辑</el-button>
            <el-button type="text" @click="handleView(scope.row, '详情')">详情</el-button>
            <el-popover
              placement="bottom"
              width="90"
              trigger="click"
              :disabled="!scope.row.children || scope.row.children.length <= 0"
            >
              <div>
                <i class="el-icon-warning"></i>
                <span>该部门有下属部门，请先删除下属部门！</span>
              </div>
              <el-button
                class="delbutton"
                type="text"
                slot="reference"
                @click="handleDel( scope.row, '删除')"
                :disabled="scope.row.children && scope.row.children.length > 0"
              >删除</el-button>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { delDepts } from '@/api/system/system'
import SearchComponent from '@/components/searchComponent'
import myform from '@/views/system/organMsg/components/form'
import Mdialog from '@/components/Mdialog'
export default {
  components: {
    myform,
    SearchComponent,
    Mdialog,
  },
  data() {
    return {
      authIdentity: 'system:organMsg',
      type: '',
      title: '',
      currentView: '',
      loading: false,
      dialogVisible: false,
      selectionChange: [],
      selectOrInputList: [
        {
          model: 'deptName',
          placeholder: '请输入部门名称',
          class: 'home',
          type: 'input',
        },
      ],
      tableData: [],
    }
  },
  created() {
    this.getDeptList()
  },
  computed: {
    ...mapState({
      deptList: (state) => state.system.deptList,
      treeList: (state) => state.system.deptTreeList,
    }),
  },
  methods: {
    ...mapActions({ getDeptList: 'system/getDeptList' }),
    submitFrom() {
      this.loading = true
      this.$refs['myform']
        .submit()
        .then(() => {
          this.loading = false
          this.cancel()
          this.getDeptList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel() {
      if (this.loading) {
        return
      }
      this.$refs['myform'].reset()
      this.dialogVisible = false
    },
    handleSearch(query) {
      this.getDeptList(query)
    },
    handleReset() {
      this.getDeptList()
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看部门信息'
      this.dialogVisible = true
      this.currentView = 'myform'

      let parents = this.deptList.find((d) => d.id == row.parentId)
      row.parentName = parents && parents.deptName
      row.updateBy = row.updateBy || row.createBy
      row.updateTime = this.parseTime(row.updateTime || row.createTime, '{y}-{m}-{d} {h}:{i}')

      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleEdit(row) {
      this.type = 'update'
      this.title = '编辑部门'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delDepts(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getDeptList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleAdd(row) {
      this.type = 'save'
      this.title = '新增部门'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    cellStyle(row) {
      // textAlign: 'center'
      if (row.column.label == '单号' || (this.changeMechNum && row.column.label == '标号')) {
        return { color: '#2f4cdd', cursor: 'pointer' }
      } else {
        return { color: '#000000' }
      }
    },
  },
}
</script>

<style  scoped lang="less">
@import '~@/assets/variables.less';
::v-deep {
  .listTable {
    border: 2px solid #ebeffa;
    // border-top-right-radius: 16px;
    // border-top-left-radius: 16px;
    // border-bottom-width: 1px;
    border-radius: @table-radius-size;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }
  }
  .el-table__footer-wrapper {
    margin-top: 0px;
  }
  .el-table__cell {
    border-right: none;
  }
  .el-table__header-wrapper {
    border-radius: 16px 16px 0px 0px;
  }
  .el-table th.el-table__cell {
    background: #ece4ce;
    color: #282c38;
    font-size: 14px;
    .cell {
      border-right: 1px solid #cfcff4;
    }
  }
  // .el-table .el-table__cell {
  //   text-align: left;
  // }
  // 分页
  .pagination {
    //padding-right: 60px;
    height: 44px;
    // position: fixed;
    right: 15px;
    bottom: 20px;
    .el-pagination {
      display: -moz-box;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flexbox;
      display: flex;

      -webkit-box-pack: right;
      -ms-justify-content: right;
      -moz-justify-content: right;
      -o-justify-content: right;
      -webkit-justify-content: right;
      justify-content: right;

      -webkit-box-align: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -webkit-align-items: center;
      align-items: center;

      height: 100%;
      padding: 0;
    }

    // 上一页
    .btn-prev,
    .btn-next {
      width: 100px;
      height: 100%;
      border-radius: 12px;

      .el-icon {
        text-align: center;
        margin: auto;
        font-size: 14px;

        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-prev {
      background-color: #b7b7b7;

      .el-icon {
        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-next {
      background-color: #c59429;

      .el-icon {
        &::after {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '>';
          color: #d3d6e4;
        }

        &::before {
          content: '下一页';
          color: #ffffff;
          margin-right: 5px;
          font-size: 14px;
        }
      }
    }

    .el-pager {
      display: flex;
      align-items: center;
      height: 100%;
      background-color: #e3e4eb;
      border-radius: 12px;

      .number {
        width: 40px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        background-color: #e3e4eb;
      }

      .active {
        background-color: #ffffffeb !important;
        border-radius: 12px;
        color: black !important;
      }
    }
  }
}
.wrap {
  font-size: 14px;
}
/deep/ .delbutton.el-button--text {
  color: red;
  margin-left: 10px;
}
/deep/ .el-button--text {
  font-size: 14px;
}
.left-right {
  display: flex;
  .left {
    width: 200px;
  }
  .right {
    flex: 1;
    margin-left: 20px;
  }
}
</style>